import { type BaseTag } from '@hungryroot/rest';
import { type PreferenceOption } from '@hungryroot/rest/api/v2/preference_options/get/get_preference_options';

export function preferenceOptionToBaseTag(input: PreferenceOption): BaseTag {
  return {
    id: input.tag_id,
    name: input.name,
    remark: input.description,
    image_url: input.image_url,
    thumbnail_url: input.thumbnail_url,
  };
}
